import { render, staticRenderFns } from "./transaction-overview.vue?vue&type=template&id=62bd94ea&"
import script from "./transaction-overview.vue?vue&type=script&lang=js&"
export * from "./transaction-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports